import React from 'react';
import { Badge } from './ui/badge';

const LogsTab = ({ activityLogs }) => {
  return (
    <div className="space-y-2" data-testid="tab-logs">
      {activityLogs.length === 0
        ? <div className="text-center text-gray-400 py-6">Log kaydı yok</div>
        : activityLogs.map((log, i) => (
          <div key={log.id || `log-${log.timestamp}-${i}`} className="bg-gray-800/60 border border-gray-700/40 rounded-lg p-3 text-sm">
            <div className="flex justify-between items-start">
              <div>
                <Badge className="bg-blue-600 text-white text-xs mr-2">{log.action}</Badge>
                <span className="text-gray-400 text-xs">{log.userEmail}</span>
              </div>
              <span className="text-gray-500 text-xs">{new Date(log.timestamp).toLocaleString('tr-TR')}</span>
            </div>
            {log.details && <p className="text-gray-300 text-xs mt-1">{log.details}</p>}
          </div>
        ))
      }
    </div>
  );
};

export default LogsTab;
